import AjaxCall from '../ws/ajax-call';
import AjaxUrls from '../constants/ajax-url';
import TrackingAction from '../constants/tracking-action';
import ParamStore from '../logic/stores/param-store';
import ErrorLogger from '../infrastructure/error-logger';

export default class JmServices {

    static trackEvent(componentId, options) {
        try {
            if (!options.trackingValue) {
                throw new Error(`JLS Missing JmServices.trackEvent preconditions; Options: ${JSON.stringify(options)}`);
            }

            return AjaxCall.call({
                isAsync: options.isAsync === undefined ? true : options.isAsync,
                url: AjaxUrls.jm.tracking.createEvent.url,
                method: AjaxUrls.jm.tracking.createEvent.method,
                requestData: {
                    trackingEventId: options.trackingValue,
                    properties: {"Container": ParamStore.getModel(componentId).tracking.segment.containerProperty},
                    trackingEventName: JmServices._findTrackingName(options.trackingValue)
                }
            })
        }
        catch (ex) {
            ErrorLogger.log(ex);
            throw ex;
        }
    }

    static _findTrackingName(trackingValue) {
        for (let trackingActionName in TrackingAction) {
            if (TrackingAction.hasOwnProperty(trackingActionName) &&
                TrackingAction[trackingActionName] === trackingValue) {
                return trackingActionName;
            }
        }

        return 'UNKNOWN';
    }
}


/** WEBPACK FOOTER **
 ** ./src/ws/jm-services.js
 **/